import { z } from 'zod'
import { Uuid, Version, blankAsAbsent, moneyField } from './primitives.ts'
import { BULK_TOO_MANY, ORDER_BULK_MAX } from '../order-board.ts'
import { PageQuery } from './pagination.ts'

/**
 * ══ HỢP ĐỒNG API — CHÀO GIÁ THẦU PHỤ (F28) ═══════════════════════════════════════════════════
 * Nguồn sự thật duy nhất cho `/api/v1/az/chao-gia` và `/api/v1/ncc/chao-gia`.
 *
 * ⚠ HAI HỌ CỬA, HAI LƯỢC ĐỒ KHÁC HẲN. Cửa của thầu phụ KHÔNG có `vendorId` ở bất kỳ đâu: thầu phụ
 *   nào là do PHIÊN quyết, không do thân request khai. Cho khai là mở đúng cái cửa mà cả nghiệp vụ
 *   này tồn tại để đóng — một nhà thầu bỏ giá dưới tên nhà thầu khác.
 */


export const ListBidQuery = PageQuery.extend({
  status: blankAsAbsent(z.enum(['open', 'closed', 'awarded', 'cancelled'])),
})

export const BidIdParams = z.object({ id: Uuid })
export const BidStepBody = z.object({ version: Version })

export const CancelBidBody = z.object({
  version: Version,
  reason: z.string().min(1, 'Phải ghi lý do huỷ phiên.'),
})

/** 📣 Mở thầu hàng loạt từ danh sách điều hành. */
export const OpenBiddingBody = z.object({ jobIds: z.array(Uuid).min(1, 'Chưa chọn đơn nào.').max(ORDER_BULK_MAX, BULK_TOO_MANY) })

/** Chọn một chào giá. ≥ 3 chào giá thì `reason` bắt buộc — máy chủ kiểm. */
export const PickOfferBody = z.object({ version: Version, offerId: Uuid, reason: z.string().max(1000) })

export const SubmitOfferBody = z.object({
  requestId: Uuid,
  amount: moneyField('Giá chào'),
  leadDays: z.number().int().min(0).max(365).optional(),
  note: blankAsAbsent(z.string()),
  companyName: z.string().trim().min(1, 'Chưa nhập tên công ty.'),
  taxCode: z.string().trim().regex(/^\d{10,13}$/, 'Mã số thuế phải gồm 10–13 chữ số.'),
  phone: blankAsAbsent(z.string()),
  serviceMode: z.enum(['rail', 'road', 'sea']),
  hasInvoice: z.boolean(),
  vatPercent: z.number().min(0).max(100).optional(),
})

export const WithdrawOfferBody = z.object({ requestId: Uuid })

export const MyBidQuery = z.object({ limit: PageQuery.shape.limit })

export type ListBidQueryT = z.infer<typeof ListBidQuery>
export type CancelBidBodyT = z.infer<typeof CancelBidBody>
export type OpenBiddingBodyT = z.infer<typeof OpenBiddingBody>
export type PickOfferBodyT = z.infer<typeof PickOfferBody>
export type SubmitOfferBodyT = z.infer<typeof SubmitOfferBody>
export type WithdrawOfferBodyT = z.infer<typeof WithdrawOfferBody>
export type MyBidQueryT = z.infer<typeof MyBidQuery>
